import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiMembersEmployeeConditionSubmissionsSubmissionRepliesCreateRequestType,
  ApiMembersEmployeeConditionSubmissionsSubmissionRepliesCreateResponseType,
} from "~/domains";

type RequestDataType = {
  employeeConditionSubmissionId: string;
  body: ApiMembersEmployeeConditionSubmissionsSubmissionRepliesCreateRequestType;
};

const request = ({ employeeConditionSubmissionId, body }: RequestDataType) => {
  return new ApiClient()
    .post<ApiMembersEmployeeConditionSubmissionsSubmissionRepliesCreateResponseType>(
      `/api/members/employee_condition_submissions/${employeeConditionSubmissionId}/submission_replies`,
      {
        reply: body,
      },
    )
    .then((res) => res.data);
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApiMembersEmployeeConditionSubmissionsSubmissionRepliesCreate =
  ({ options = {} }: PropsType = {}): UseMutationResult<
    ApiMembersEmployeeConditionSubmissionsSubmissionRepliesCreateResponseType,
    RequestDataType
  > => {
    return useMutation(request, { ...options });
  };
